// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperFinderUpsell-cls1_uPI","cls2":"PaperFinderUpsell-cls2_WAb PaperFinderUpsell-cls1_uPI"};